import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Statistics from './components/Statistics';
import UserManage from './components/UserManage';
import { useDispatch, useSelector } from 'react-redux';
import Nav from './components/Nav/Nav';
import Header from './components/Header/Header';
import Payment from './components/Payment';
import Announcement from './components/Announcement';
import Promotion from './components/Promotion';
import PromotionStatistics from './components/PromotionStatistics';
import PromotionDetails from './components/PromotionDetails';
import SettlementManage from './components/SettlementManage';
import SettlementDetails from './components/SettlementDetails';
import Support from './components/Support';
import Function from './components/Function/Function';
import Login from './components/Login/Login';
import { fetchUser } from './store/auth';
import 'semantic-ui-css/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './index.module.scss';
import styles from './App.module.scss';

function LayoutWithNav({ children }) {
  return (
    <>
      <Header />
      <div className={styles.app}>
        <div className={styles.box}>
          <Nav />
          <div style={{ flex: 1 }}>{children}</div>
        </div>
      </div>
    </>
  );
}
function AppRoutes() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const needNav = location.pathname !== '/login';
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (!token && location.pathname !== '/login') {
      navigate('/login', { replace: true });
    }
  }, [token, location.pathname, navigate]);

  useEffect(() => {
    if (location.pathname !== '/login' && !user) {
      dispatch(fetchUser());
    }
  }, [location.pathname, dispatch, needNav, user]);

  if (!token && location.pathname !== '/login') {
    return null;
  }

  return needNav ? (
    <LayoutWithNav>
      <Routes>
        <Route path="/" element={<Statistics />} />
        <Route path="/userManage" element={<UserManage />} />
        <Route path="/announcement" element={<Announcement />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/promotion" element={<Promotion />} />
        <Route path="/promotionStatistics" element={<PromotionStatistics />} />
        <Route path="/promotionDetails" element={<PromotionDetails />} />
        <Route path="/settlementManage" element={<SettlementManage />} />
        <Route path="/settlementDetails" element={<SettlementDetails />} />
        <Route path="/support" element={<Support />} />
        <Route path="/function" element={<Function />} />
      </Routes>
    </LayoutWithNav>
  ) : (
    <Routes>
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}
function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
